// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"ec94a691","685":"67eb3ded"}[chunkId] + ".chunk.js";
};